import * as React from 'react'
import * as R from 'ramda'
import * as PropTypes from 'prop-types'

import * as Forms from '@rushplay/forms'
import * as Herz from '@rushplay/herz'

import { Button } from './buttons/button'

export function SubmitButton(props) {
  const form = Forms.useFormContext()

  const errors =
    props.onlyScopes == null
      ? Forms.getFormErrors(form.state)
      : R.pick(props.onlyScopes, Forms.getFormErrors(form.state))

  const submitKey = `${form.name}.button.submit`
  const translate = Herz.I18n.useTranslate(() => [submitKey])

  return (
    <Button
      loading={props.loading}
      disabled={
        Object.keys(errors).length !== 0 || props.loading || props.disabled
      }
      sx={{
        width: '100%',
        ...props.sx,
      }}
      type="submit"
      variant="primary"
    >
      {!props.children ? translate(submitKey) : props.children}
    </Button>
  )
}

SubmitButton.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onlyScopes: PropTypes.arrayOf(PropTypes.string),
  sx: PropTypes.object,
}
